import React from 'react';
import { string, arrayOf, shape, func } from 'prop-types';
import { Typography, FormControl, InputLabel, FormHelperText } from '@mui/material';

import { Select } from '../../../../../../components';

import staticText from '../../../../../../localization/Application/Members/inviteEditUsers';

const RoleSelect = ({
  dashboardPermissionRoles,
  handleRole,
  selectedRole,
  error,
}) => {
  const decorateSelect = (roleName) => {
    const role = dashboardPermissionRoles.find(item => item.name === roleName);
    return (
      <div>
        <Typography
          variant="body2"
          color="text.primary"
          component="p"
          marginBottom={0.5}
          sx={theme => ({ fontFamily: theme.typography.bold.fontFamily })}
        >
          {role.displayName}
        </Typography>
        <Typography
          component="p"
          variant="caption"
          sx={{ textWrap: 'wrap' }}
        >
          {role.description}
        </Typography>
      </div>
    );
  };

  const labelId = 'role-select-label';

  return (
    <FormControl key="role-select" fullWidth>
      <InputLabel id={labelId}>{staticText.roleAccess.label}</InputLabel>
      <Typography variant="caption" mb={1}>
        {staticText.roleAccess.selectAccess}
      </Typography>
      <Select
        id="role-select"
        value={selectedRole}
        onChange={handleRole}
        labelId={labelId}
        error={Boolean(error)}
        options={dashboardPermissionRoles.map(({ name }) => ({
          value: name,
          label: decorateSelect(name),
        }))}
        menuProps={{
          width: '552px',
          height: '300px',
        }}
      />
      {error && (
        <FormHelperText error>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default RoleSelect;


RoleSelect.propTypes = {
  dashboardPermissionRoles: arrayOf(
    shape({
      name: string,
      displayName: string,
      description: string,
    }),
  ).isRequired,
  handleRole: func.isRequired,
  selectedRole: string.isRequired,
  error: string.isRequired,
};
